<template>
    <NuxtLink :to="`/news/${data.slug}`" class="grid grid-cols-12 mb-12 max-md:gap-y-5 md:mb-8 last:mb-0">
        <div class="col-span-12 md:col-span-3">
            <Media :data="data.media[0]" class="block aspect-card" v-if="data.media[0]"/>
            <div v-if="!data.media[0]" class="bg-green aspect-card w-full"></div>
        </div>
        <div class="col-span-12 md:col-span-5">
            <p class="text-mini">{{$dateFormat(data.postDate)}}</p>
            <h3 class="headline mt-1 mb-4">{{data.title}}</h3>

            <div class="text-base-serif mb-4" v-html="data.excerpt"></div>

            <ElementButton :styleClasses="'text-mini'" title="Læs mere" englishTitle="Read More"/>
        </div>
    </NuxtLink>
</template>

<script setup>
const { $dateFormat } = useNuxtApp()

const props = defineProps({
    data: {
        type: Object,
        default: {
            title: 'Element Card',
            slug: 'lorem-ipsum',
            postDate: "2024-06-04T07:00:00+00:00",
            excerpt: "Vil du researche i havneområdet, udforske det maritime miljø og udforme et afsluttende performativt værk på Kulturhavn Festival d. 24. august i Sydhavn?",
            media: {
                url: 'https://sydhavnteater:8890/assets/Screenshot-2024-07-01-at-14.12.29.jpg',
                width: 1396,
                height: 863,
                mimeType: 'image/jpeg',
                title: 'Hero image'
            },
        }
    }
})
</script>

<style lang="scss" scoped>
:deep(.arrow-button) {
    svg {
        width: 1.2rem;
    }
}

:deep(.media) img {
    @apply w-full h-full object-cover;
}
</style>